import { RafpRequestStatusTypeEnum } from 'APIPackage/KnmModule/enums/RafpRequestStatusTypeEnum';

export function validateRafpNzaStatus(): (value: RafpRequestStatusTypeEnum) => string | undefined {
  return (value?: RafpRequestStatusTypeEnum) => {
    if (value === RafpRequestStatusTypeEnum.ERROR_RETRY) {
      return 'Запрашиваемые сведения не могут быть предоставлены в настоящий момент. Автоматический запрос будет произведен через час.';
    }
    if (value === RafpRequestStatusTypeEnum.NOT_FOUND) {
      return 'Запрашиваемые сведения отсутствуют в РАФП, проверьте введенные значения. Если у данного иностранного юридического лица нет филиалов и представительств, зарегистрированных на территории РФ, то необходимо выбрать другой тип контролируемого лица – Иностранные юридические лица.';
    }

    return undefined;
  };
}
